'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _scoresheet = require('./scoresheet');

var _scoresheet2 = _interopRequireDefault(_scoresheet);

var _stages = require('../../../../../stages');

var _events = require('../../../../../events');

var _events2 = _interopRequireDefault(_events);

var _routerHistory = require('../../../../../router-history');

var _routerHistory2 = _interopRequireDefault(_routerHistory);

var _ifeisIsomorphic = require('ifeis-isomorphic');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AdjudicationController = function () {
  function AdjudicationController(feis, stages, $state, msgService, fEventService, fRouterHistoryService) {
    _classCallCheck(this, AdjudicationController);

    this.feis = feis;
    this.stages = stages;
    this._svc = {
      $state: $state, fRouterHistoryService: fRouterHistoryService, msgService: msgService
    };
    this.eventService = fEventService.for(this.feis.id);

    this.loadStages();
  }

  _createClass(AdjudicationController, [{
    key: 'loadStages',
    value: function loadStages() {
      var _this = this;

      this.loading++;
      this.stages.all().then(function (s) {
        _this.stages = s;
        _this.loading--;
      });
    }
  }, {
    key: 'loadStage',
    value: function loadStage(index) {
      var _this2 = this;

      this.stages[index].schedule().then(function (events) {
        _this2.stages[index].events = _this2.cleanPlaceholders(events);
        if (_this2.stages[index].events.length > 0) {
          var params = {
            stage: _this2.stages[index]._stage.id,
            event: _this2.stages[index].events[0].id,
            stages: _this2.stages
          };
          _this2._svc.$state.go('feiseanna.one.admin.adjudication.scoresheet', params);
        } else {
          _this2.toast('No events for that stage.');
        }
      });
    }
  }, {
    key: 'cleanPlaceholders',
    value: function cleanPlaceholders(events) {
      var nevents = [];
      for (var i = 0; i < events.length; i++) {
        if (!events[i].$placeholder) {
          nevents.push(events[i]);
        }
      }
      return nevents;
    }
  }, {
    key: 'toast',
    value: function toast(msg) {
      this._svc.msgService.displayErrorMsg(msg);
    }
  }, {
    key: 'back',
    value: function back() {
      this._svc.fRouterHistoryService.back();
    }
  }, {
    key: 'getEventName',
    value: function getEventName() {
      if (this.currentEvent) {
        return (0, _ifeisIsomorphic.getDescription)(this.currentEvent);
      }
    }
  }]);

  return AdjudicationController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.adjudication', ['ifeis.routes.feiseanna.one.admin.adjudication.scoresheet', 'ngMaterial', 'ui.router', 'ifeis.router-history', 'ifeis.stages.service', 'ifeis.events']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.adjudication', {
    url: '/adjudication',
    controller: 'AdjudicationController',
    controllerAs: 'ctrl',
    template: require('./tpl.html'),
    resolve: {
      stages: function stages($stateParams, fStages) {
        return fStages.for($stateParams.id);
      }
    }
  });
}).controller('AdjudicationController', AdjudicationController);


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/adjudication/index.js
// module id = 536
// module chunks = 0